import {
  JointFundsActionConstants,
  DOWNLOAD_TRANSACTION_STATEMENTS,
  DOWNLOAD_TRANSACTION_STATEMENTS_SUCCESS,
  DOWNLOAD_TRANSACTION_STATEMENTS_FAILED,
  GET_GENERAL_CONTRIBUTIONS,
  GET_GENERAL_CONTRIBUTIONS_SUCCESS,
  GET_GENERAL_CONTRIBUTIONS_FAILED,
  GET_PERSONAL_CONTRIBUTION,
  GET_PERSONAL_CONTRIBUTION_SUCCESS,
  GET_PERSONAL_CONTRIBUTION_FAILED,
  CONTRIBUTE_FUNDS,
  CONTRIBUTE_FUNDS_SUCCESS,
  CONTRIBUTE_FUNDS_FAILED,
  TRANSFER_TO_WALLET,
  TRANSFER_TO_WALLET_SUCCESS,
  TRANSFER_TO_WALLET_FAILED,
  SET_GENERAL_AMOUNT,
  SET_GENERAL_AMOUNT_SUCCESS,
  SET_GENERAL_AMOUNT_FAILED,
  GET_GENERAL_AMOUNT,
  GET_GENERAL_AMOUNT_SUCCESS,
  GET_GENERAL_AMOUNT_FAILED,
  GET_JOINT_FUND_WALLET,
  GET_JOINT_FUND_WALLET_SUCCESS,
  GET_JOINT_FUND_WALLET_FAILED,
} from './constants'

import { IJointFunds } from '../../interfaces/joint-funds'
import { DEFAULT_JOINT_FUNDS } from './joint-funds'

const initialState: IJointFunds = DEFAULT_JOINT_FUNDS

export const jointFundsReducer = (
  state: IJointFunds = initialState,
  action: JointFundsActionConstants
) => {
  switch (action.type) {
    case DOWNLOAD_TRANSACTION_STATEMENTS:
      return { ...state, download_transaction_statements_loading: true }
    case DOWNLOAD_TRANSACTION_STATEMENTS_SUCCESS:
      return {
        ...state,
        download_transaction_statements_loading: false,
        download_transaction_statements: action.payload.data
      }
    case DOWNLOAD_TRANSACTION_STATEMENTS_FAILED:
      return {
        ...state,
        download_transaction_statements_loading: false,
        error: { ...state.error, download_transaction_statements_error: action.payload }
      }

    case GET_GENERAL_CONTRIBUTIONS:
      return { ...state, get_general_contributions_loading: true }
    case GET_GENERAL_CONTRIBUTIONS_SUCCESS:
      return {
        ...state,
        get_general_contributions_loading: false,
        get_general_contributions: action.payload.data.data,
        get_general_contributions_pagination: action.payload.data.pagination,
      }
    case GET_GENERAL_CONTRIBUTIONS_FAILED:
      return {
        ...state,
        get_general_contributions_loading: false,
        error: { ...state.error, get_general_contributions_error: action.payload }
      }

    case GET_PERSONAL_CONTRIBUTION:
      return { ...state, get_personal_contributions_loading: true }
    case GET_PERSONAL_CONTRIBUTION_SUCCESS:
      return {
        ...state,
        get_personal_contributions_loading: false,
        get_personal_contributions_pagination: action.payload.data.pagination,
        get_personal_contributions: action.payload.data.data,
        get_personal_contributions_totals: action.payload.data.totals
      }
    case GET_PERSONAL_CONTRIBUTION_FAILED:
      return {
        ...state,
        get_personal_contributions_loading: false,
        error: { ...state.error, get_personal_contributions_error: action.payload }
      }

    case CONTRIBUTE_FUNDS:
      return { ...state, contribute_funds_loading: true }
    case CONTRIBUTE_FUNDS_SUCCESS:
      return {
        ...state,
        contribute_funds_loading: false,
        contribute_funds: action.payload.data.data
      }
    case CONTRIBUTE_FUNDS_FAILED:
      return {
        ...state,
        contribute_funds_loading: false,
        error: { ...state.error, contribute_funds_error: action.payload }
      }
      
    case TRANSFER_TO_WALLET:
      return { ...state, transfer_to_wallet_loading: true }
    case TRANSFER_TO_WALLET_SUCCESS:
      return {
        ...state,
        transfer_to_wallet_loading: false,
        transfer_to_wallet: action.payload.data.data
      }
    case TRANSFER_TO_WALLET_FAILED:
      return {
        ...state,
        transfer_to_wallet_loading: false,
        error: { ...state.error, transfer_to_wallet_error: action.payload }
      }

    case SET_GENERAL_AMOUNT:
      return { ...state, set_general_amount_loading: true }
    case SET_GENERAL_AMOUNT_SUCCESS:
      return {
        ...state,
        set_general_amount_loading: false,
        set_general_amount: action.payload.data.data
      }
    case SET_GENERAL_AMOUNT_FAILED:
      return {
        ...state,
        set_general_amount_loading: false,
        error: { ...state.error, set_general_amount_error: action.payload }
      }

    case GET_GENERAL_AMOUNT:
      return { ...state, get_general_amount_loading: true }
    case GET_GENERAL_AMOUNT_SUCCESS:
      return {
        ...state,
        get_general_amount_loading: false,
        get_general_amount: action.payload.data.data
      }
    case GET_GENERAL_AMOUNT_FAILED:
      return {
        ...state,
        get_general_amount_loading: false,
        error: { ...state.error, get_general_amount_error: action.payload }
      }

    case GET_JOINT_FUND_WALLET:
      return { ...state, get_joint_fund_wallet_loading: true }
    case GET_JOINT_FUND_WALLET_SUCCESS:
      return {
        ...state,
        get_joint_fund_wallet_loading: false,
        get_joint_fund_wallet: action.payload.data.data
      }
    case GET_JOINT_FUND_WALLET_FAILED:
      return {
        ...state,
        get_joint_fund_wallet_loading: false,
        error: { ...state.error, get_joint_fund_wallet_error: action.payload }
      }

    default:
      return state
  }
}
